import { render } from "./hero-component.vue?vue&type=template&id=e566f058&ts=true"
import script from "./hero-component.vue?vue&type=script&lang=ts"
export * from "./hero-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__